import { render, staticRenderFns } from "./ManageGate.vue?vue&type=template&id=0e70c388&scoped=true&"
import script from "./ManageGate.vue?vue&type=script&lang=js&"
export * from "./ManageGate.vue?vue&type=script&lang=js&"
import style0 from "./ManageGate.vue?vue&type=style&index=0&id=0e70c388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e70c388",
  null
  
)

export default component.exports